import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { RouterTabs } from '~/components/RouterTabs';
import { PageContainer } from '~/components/page-layout';
import { useAppContext } from '~/contexts';
import { LayoutToolbar } from '../components';

export interface LayoutLayoutProps {
  children: ReactNode;
}

export const LayoutLayout = ({ children }: LayoutLayoutProps) => {
  const location = useLocation();
  const { currentNetwork } = useAppContext();
  const { t } = useTranslation();

  return (
    <>
      <LayoutToolbar />
      <nav>
        <RouterTabs
          tabs={[
            { label: t('pages.layouts.tabs.design'), to: '../design' },
            ...(currentNetwork.canManage.value
              ? [
                  {
                    label: t('common.tabs.audit_logs'),
                    to: { pathname: '../audit-logs', search: location.search },
                  },
                ]
              : []),
          ]}
          variant="scrollable"
        />
      </nav>
      <PageContainer>{children}</PageContainer>
    </>
  );
};
